import TextField from '@mui/material/TextField';
import { FC } from 'react';

import { sanitizeBaseNameInput } from '../media-manager/sanitize-file-name';

export type TFileNameFieldProps = {
  value: string;
  onChange: (value: string) => void;
  onEnter?: () => void;
};

/** Lowercase file-name input. Spaces become hyphens as the user types. */
export const FileNameField: FC<TFileNameFieldProps> = ({ value, onChange, onEnter }) => (
  <TextField
    label="File name"
    size="small"
    fullWidth
    value={value}
    onChange={e => onChange(sanitizeBaseNameInput(e.target.value))}
    onKeyDown={e => {
      if (e.key === 'Enter' && onEnter) {
        e.preventDefault();
        onEnter();
      }
    }}
    helperText="Lowercase letters, numbers and hyphens. The extension is added automatically."
    inputProps={{ maxLength: 100 }}
  />
);
